import { render, staticRenderFns } from "./DeleteData.vue?vue&type=template&id=fb35c97a&"
import script from "./DeleteData.vue?vue&type=script&lang=js&"
export * from "./DeleteData.vue?vue&type=script&lang=js&"
import style0 from "./DeleteData.vue?vue&type=style&index=0&id=fb35c97a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports